/* SCUSA v2 review popup — shared behavior (event-delegated, loaded once).
   Powers every [data-scr-open] trigger + [data-scr-full] photo thumbnail on the page. */
(function () {
  // Relocate modals to <body> so a transformed/overflow-hidden card can never trap
  // a position:fixed modal (cards use transform on hover). Runs on load + on open.
  function toBody(m) { if (m && m.parentNode !== document.body) document.body.appendChild(m); }
  function relocateAll() {
    var ms = document.querySelectorAll('.scr-modal');
    for (var i = 0; i < ms.length; i++) toBody(ms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relocateAll);
  else relocateAll();

  function closeAll() {
    var ms = document.querySelectorAll('.scr-modal');
    for (var i = 0; i < ms.length; i++) ms[i].hidden = true;
    document.body.classList.remove('scr-open');
  }
  function lightbox() {
    var el = document.getElementById('scr-lightbox');
    if (!el) {
      el = document.createElement('div');
      el.id = 'scr-lightbox';
      el.className = 'scr-lightbox';
      el.hidden = true;
      el.innerHTML = '<button class="scr-lightbox__x" type="button" aria-label="Close photo">×</button><img alt="Customer review photo">';
      document.body.appendChild(el);
      el.addEventListener('click', function () { el.hidden = true; });
    }
    return el;
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-scr-open]');
    if (openBtn) {
      e.preventDefault(); e.stopPropagation();  // don't trigger a wrapping card <a>
      var m = document.getElementById(openBtn.getAttribute('data-scr-open'));
      if (m) {
        toBody(m);
        closeAll();
        m.hidden = false;
        document.body.classList.add('scr-open');
        var l = m.querySelector('.scr-modal__list');
        if (l) l.scrollTop = 0;
      }
      return;
    }
    if (e.target.closest('[data-scr-close]')) { e.preventDefault(); closeAll(); return; }
    var nav = e.target.closest('[data-scr-nav]');
    if (nav) { e.preventDefault(); window.location.href = nav.getAttribute('data-scr-nav'); return; }
    var thumb = e.target.closest('[data-scr-full]');
    if (thumb) {
      e.stopPropagation();
      var lb = lightbox();
      lb.querySelector('img').src = thumb.getAttribute('data-scr-full');
      lb.hidden = false;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var lb = document.getElementById('scr-lightbox');
      if (lb && !lb.hidden) { lb.hidden = true; } else { closeAll(); }
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      var t = e.target.closest && (e.target.closest('[data-scr-open]') || e.target.closest('[data-scr-close]'));
      if (t) { e.preventDefault(); t.click(); }
    }
  });
})();
